import React, { forwardRef, useEffect, useRef, useState } from "react";

const CustomSelect = ({ label, keyField, value, editHandler, Options }) => {
  const statusRef = useRef(null);
  const [statusFlag, setStatusFlag] = useState(false);
  const [activeOption, setActiveOption] = useState(0);
  useEffect(() => {
    setActiveOption(Options.indexOf(value));
    document.addEventListener("mousedown", HandleOutSideClick);
    return () => {
      document.removeEventListener("mousedown", HandleOutSideClick);
    };
  }, []);

  const HandleOutSideClick = (e) => {
    if (
      statusRef &&
      statusRef.current &&
      statusRef.current.contains(e.target)
    ) {
      return;
    }
    setStatusFlag(false);
  };

  const handleScroll = (value) => {
    let ul = document.getElementById("status-list");
    if (ul?.children?.length) {
      var elHeight = ul?.children?.[0]?.offsetHeight;
      var scrollTop = ul?.scrollTop;
      var viewport = scrollTop + ul?.offsetHeight;
      var elOffset = elHeight * value;

      if (elOffset < scrollTop || elOffset + elHeight > viewport) {
        ul.scrollTop = elOffset - elHeight * 7;
      }
    }
  };
  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      let selected = Options[activeOption];
      editHandler({ currentTarget: { id: keyField, value: selected } });
      setStatusFlag(false);
    } else if (e.keyCode === 38) {
      if (activeOption === 0) {
        return;
      }
      handleScroll(activeOption - 1);
      setActiveOption(activeOption - 1);
    } else if (e.keyCode === 40) {
      if (activeOption < Options?.length - 1) {
        handleScroll(activeOption + 1);
        setActiveOption(activeOption + 1);
      }
    }
  };

  return (
    <div className="form-group edit-dropdown-select arrow-menu">
      <label className="mandatory">
        {label} <span>*</span>
      </label>
      <div className="dropdown station-dropdown dropdownContainer">
        <input
          className="form-control"
          autoComplete="off"
          onClick={() => !statusFlag && setStatusFlag(true)}
          value={value}
          onKeyDown={onKeyDown}
        />
        {statusFlag && (
          <ul
            id="status-list"
            ref={statusRef}
            className={`dropdown-content ${statusFlag ? "show" : ""}`}
          >
            {Options.map((_map, index) => {
              return (
                <li
                  key={index}
                  className={`list-group-item ${
                    index === activeOption ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveOption(index);
                    editHandler({
                      currentTarget: { id: keyField, value: _map },
                    });
                    setStatusFlag(false);
                  }}
                  value={_map}
                >
                  {_map}
                  {_map === value && <i className="fa fa-check fa-lg"></i>}
                </li>
              );
            })}
          </ul>
        )}
      </div>
      <i
        onClick={() => !statusFlag && setStatusFlag(true)}
        className="fa fa-caret-down caret-icon dropdownBottomArrow"
      ></i>
    </div>
  );
};

export default CustomSelect;
